import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';
import { hide as hideElement, show as showElement } from '@frontend/utils/dom';
import Keyboard from '@frontend/utils/keyboard';

export default class extends Controller {
  static targets = ['overlay', 'window', 'body'];

  connect() {
    document.addEventListener(
      'modal-window:display',
      this.handleDisplay.bind(this)
    );
    document.addEventListener(
      'modal-window:load-and-display',
      this.loadAndDisplayUrl.bind(this)
    );
    document.addEventListener('modal-window:hide', this.hide.bind(this));

    Keyboard.map('escape', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.hide();
    });
  }

  display(html) {
    this.bodyTarget.innerHTML = html;
    if (html === null) {
      hideElement(this.windowTarget);
    } else {
      showElement(this.windowTarget);
    }
    this.disableBackgroundScrolling();
    this.previouslyActiveElement = document.activeElement;
    this.bodyTarget.focus();
    showElement(this.overlayTarget);
  }

  hide() {
    if (this.previouslyActiveElement) {
      this.previouslyActiveElement.focus();
      this.previouslyActiveElement = null;
    }
    this.reEnableBackgroundScrolling();
    hideElement(this.overlayTarget);
  }

  async loadAndDisplay(url) {
    const response = await get(url);
    if (response.ok) {
      const html = await response.text;
      this.display(html);
    }
  }

  disableBackgroundScrolling() {
    document.querySelector('html').classList.add('prevent-scroll');
  }

  reEnableBackgroundScrolling() {
    document.querySelector('html').classList.remove('prevent-scroll');
  }

  loadAndDisplayUrl(event) {
    const url = event.params?.url || event.detail?.url;
    this.loadAndDisplay(url);
  }

  handleDisplay({ detail: { html } }) {
    this.display(html);
  }
}

export function display(html) {
  document.body.dispatchEvent(
    new CustomEvent('modal-window:display', {
      bubbles: true,
      detail: { html },
    })
  );
}

export function loadAndDisplay(url) {
  document.body.dispatchEvent(
    new CustomEvent('modal-window:load-and-display', {
      bubbles: true,
      detail: { url },
    })
  );
}

export function hide() {
  document.body.dispatchEvent(
    new CustomEvent('modal-window:hide', { bubbles: true })
  );
}
